import axios from 'axios';

let api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: false
});

axios.defaults.withCredentials = false;

export default api;